module["exports"] = [
  "Allée",
  "Voie",
  "Rue",
  "Avenue",
  "Boulevard",
  "Quai",
  "Passage",
  "Impasse",
  "Place"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/fr/address/street_prefix.js
// module id = 2952
// module chunks = 1610